import Mock from '@/mocks/Mock'
import { Alert } from '@/models/WeatherWarning'

export default class HistoryMock extends Mock<Alert> {
  constructor() {
    super('weather_warning')
  }

  get() {
    return this.data
  }
}
